import React, {useState, useEffect, useRef} from "react";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {functions} from "../../../constants/common-functions";

export default function UtilisationRoomPanel({roomId}){
	
	
	const [roomName, setRoomName] = useState("");
	const [roomDescription, setRoomDescription] = useState("");
	const [roomSpaceType, setRoomSpaceType] = useState("");
	const [roomCrClass, setRoomCrClass] = useState("");
	const [roomArea, setRoomArea] = useState("");
	const [roomCapacity, setRoomCapacity] = useState("");
	
	useEffect(() => {
		if(roomId != -100){
			functions.getObjectFromAjax("/resolutionsoftwareplatform/utilisationgetroom?roomId=" + roomId, populateRoom, null);
		}
		
	}, [roomId]);
	
	const populateRoom = (room) => {
		console.log(room);
		try{
			setRoomName(room.floorCode + ': ' + room.roomName);
			setRoomDescription(room.description);
			setRoomSpaceType(room.spaceType);
			setRoomCrClass(room.crClass);
			setRoomArea(room.area);
			setRoomCapacity(room.capacity);
		}
		catch(e){}
	}
	
	const thisContainer = {
		display:"flex",
		width:"calc(100% - 40px)",
		flexDirection:"column",
		height:"256px",
		backgroundColor:"teal",
		padding:"20px"
	};
	
	const titleContainer = {
		display:"flex",
		width:"100%",
		height:"30px",
		fontSize:"16px",
		borderBorrom:"1px solid rgba(0,0,0,0.1)",
		color:"white",
		fontWeight:"bold"
	};
	
	const roomRow = {
		display:"flex",
		height:"30px",
		alignItems:"center",
	};
	
	const roomRowAlt = {
		display:"flex",
		height:"30px",
		backgroundColor:"rgba(255,255,255,0.1)",
		alignItems:"center"
	};
	
	const roomRowLabel = {
		paddingLeft:"20px",
		width:"100px",
		color:"white",
		fontSize:"12px",
		fontWeight:"bold"
	};
	
	const roomRowValue = {
		paddingLeft:"20px",
		color:"white",
		fontSize:"12px",
		flexGrow:"1"
	};
	
	return (
		<div style={thisContainer}>
			<div style={titleContainer}>
				Room Details
			</div>
			<div style={roomRow}>
				<div style={roomRowLabel}>
					Floor/Room
				</div>
				<div style={roomRowValue}>
					{roomName}
				</div>
			</div>
			<div style={roomRowAlt}>
				<div style={roomRowLabel}>
					Description:
				</div>
				<div style={roomRowValue}>
					{roomDescription}
				</div>
			</div>
			<div style={roomRow}>
				<div style={roomRowLabel}>
					Space Type
				</div>
				<div style={roomRowValue}>
					{roomSpaceType}
				</div>
			</div>
			<div style={roomRowAlt}>
				<div style={roomRowLabel}>
					CR Class
				</div>
				<div style={roomRowValue}>
					{roomCrClass}
				</div>
			</div>
			<div style={roomRow}>
				<div style={roomRowLabel}>
					Area
				</div>
				<div style={roomRowValue}>
					{roomArea}
				</div>
			</div>
			<div style={roomRowAlt}>
				<div style={roomRowLabel}>
					Places/Capacity:
				</div>
				<div style={roomRowValue}>
					{roomCapacity}
				</div>
			</div>
		</div>
	);
}